import { Link } from 'react-router-dom';
import { PawPrint, MapPin, Phone, Clock, Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-dark-brown text-cream/80 pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <PawPrint className="w-6 h-6 text-rust" />
              <span className="font-heading text-xl font-bold text-cream">Pets Valley</span>
            </div>
            <p className="text-sm leading-relaxed text-cream/60">
              Premium cats, nutritious food, and stylish accessories. Serving Anantnag and South Kashmir since 2014.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-cream mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/products" className="text-sm text-cream/60 hover:text-rust transition-colors">Shop All</Link>
              <Link to="/products?category=Live+Cats" className="text-sm text-cream/60 hover:text-rust transition-colors">Live Cats</Link>
              <Link to="/products?category=Cat+Food" className="text-sm text-cream/60 hover:text-rust transition-colors">Cat Food</Link>
              <Link to="/products?category=Accessories" className="text-sm text-cream/60 hover:text-rust transition-colors">Accessories</Link>
              <Link to="/contact" className="text-sm text-cream/60 hover:text-rust transition-colors">Contact Us</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-cream mb-4">Contact</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-2.5">
                <MapPin className="w-4 h-4 text-rust mt-0.5 shrink-0" />
                <span className="text-sm text-cream/60">Mattan Chowk, Anantnag<br />J&K, India - 192101</span>
              </div>
              <div className="flex items-center gap-2.5">
                <Phone className="w-4 h-4 text-rust shrink-0" />
                <span className="text-sm text-cream/60">+91 95413 99210</span>
              </div>
              <div className="flex items-center gap-2.5">
                <Mail className="w-4 h-4 text-rust shrink-0" />
                <span className="text-sm text-cream/60">info@petsvalley.com</span>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-heading font-bold text-cream mb-4">Shop Hours</h4>
            <div className="flex flex-col gap-2.5">
              <div className="flex items-center gap-2.5">
                <Clock className="w-4 h-4 text-rust shrink-0" />
                <span className="text-sm text-cream/60">Mon - Sat: 9AM - 8PM</span>
              </div>
              <div className="flex items-center gap-2.5">
                <Clock className="w-4 h-4 text-rust shrink-0" />
                <span className="text-sm text-cream/60">Sunday: 10AM - 6PM</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-cream/10 pt-6 text-center space-y-2">
          <p className="text-xs text-cream/40">&copy; {new Date().getFullYear()} Pets Valley. All rights reserved. Mattan Chowk, Anantnag.</p>
          <p className="text-xs text-cream/30">
            Designed &amp; Developed by <span className="text-rust font-semibold">Safeer Ahmad Mir</span> &nbsp;|&nbsp; 📞 <a href="tel:+916005889752" className="text-rust hover:text-cream transition-colors">6005889752</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
